import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-index-card',
  templateUrl: './index-card.component.html',
  styleUrls: ['./index-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule]
})
export class IndexCardComponent {
  title = input.required<string>();
  item = input.required<any>();
  selectedItem = input.required<any>();
  enabled = input<boolean>(true);

  select = output<any>();
  close = output<any>();

  active = computed(() => this.item() === this.selectedItem());

  onSelect(): void {
    this.select.emit(this.item());
  }

  onClose(): void {
    this.close.emit(this.item());
  }
}
